export default {
  "box-name": "en-style2",
  "public-btn-text1": "สมัครตอนนี้",
  "public-btn-text2": "สินค้าทั้งหมด",
  screen0: {
    title: "เงินปันผลจาก CFD",
    desc: "โปรดทราบ: การรวบรวมเงินปันผล CFD จะแสดงในยอดคงเหลือใน MT4 ของคุณเป็นการฝากหรือถอน โดยมีหมายเหตุว่า “เงินปันผล”",
  },
  screen1: {
    title: "ธุรกรรมที่ปลอดภัย",
  },
  screen2: {
    title: "โลกการเงินอยู่ใกล้แค่เอื้อม",
  },
  股息调整: "การปรับเงินปันผล",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "ทำความเข้าใจกลไกการปรับและการจัดสรรเงินปันผลของการเทรดหุ้นและดัชนี CFD",
  了解指数差价合约: "เรียนรู้เพิ่มเติมดัชนี CFD",
  了解股票差价合约: "เรียนรู้เพิ่มเติมหุ้น CFD",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "เงินปันผล คือ เงินที่บริษัทแจกจ่ายให้กับผู้ถือหุ้นเป็นประจำจากกำไรหรือกำไรสะสมของบริษัท เมื่อหุ้นจ่ายเงินปันผล ผลิตภัณฑ์ CFD ของหุ้นและดัชนีที่เกี่ยวข้องก็จะมีการปรับเงินปันผลตามที่กำหนดด้วย",
  除息日与交易优化: "วันหมดสิทธิรับเงินปันผลและการเพิ่มประสิทธิภาพการเทรด",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "วันหมดสิทธิรับเงินปันผลถูกกำหนดโดยผู้ให้บริการดัชนี หุ้น หรือกองทุน ETF ตามวันที่หุ้นพื้นฐานจะหยุดจ่ายเงินปันผล หากคุณถือคำสังซื้อคุณจะได้รับเงินปันผล แต่ถ้าคุณถือคำสั่งขายคุณจะต้องจ่ายเงินปันผล การรู้วันที่เหล่านี้ล่วงหน้าจะช่วยให้คุณจัดการผลตอบแทนได้อย่างมีประสิทธิภาพ",
  股息调整明细: "รายละเอียดการปรับเงินปันผล",
  差价合约交易中相关产品的股息数据:
    "ข้อมูลเงินปันผลสำหรับผลิตภัณฑ์ที่เกี่ยวข้องในการเทรด CFD จะถูกแสดงแยกกันระหว่างเงินปันผลของคำสั่งซื้อ และคำสั่งขาย",
  交易产品: "Trading Products",
  多头股息: "Long Dividends",
  空头股息: "Short Dividends",
  除息日: "Ex-dividend Dates",
  即刻交易: "เริ่มเทรด",
  股息的常见问题: "คำถามที่พบบ่อย",
  qaList: [
    {
      q: "1.เงินปันผลคืออะไร และวันหมดสิทธิรับเงินปันผลคืออะไร?",
      a: [
        "เงินปันผล คือ เงินที่บริษัทหรือกองทุน ETF แจกจ่ายให้กับผู้ถือหุ้นเป็นประจำจากกำไรหรือกำไรสะสมของบริษัท วันหมดสิทธิรับเงินปันผล คือ วันที่สินทรัพย์นั้นประกาศจ่ายเงินปันผลอย่างเป็นทางการและราคาจะได้รับการปรับ โดยปกติจะมีการปรับมูลค่าสุทธิหรือราคาก่อนตลาดเปิด",
        "วันหมดสิทธิรับเงินปันผลสำหรับหุ้น ดัชนี และ ETF  CFD จะทำให้เกิดการปรับราคา โดยระบบ MT4 และ MT5 จะทำการฝากเงินเข้าบัญชีสำหรับคำสั่งซื้อหรือหักเงินสดออกจากบัญชีสำหรับคำสั่งขาย ตามจำนวนเงินปันผลที่เกี่ยวข้อง",
      ],
    },
    {
      q: "2.เวลาในการปรับเงินปันผล",
      a: [
        "การปรับเงินปันผลสำหรับดัชนี CFD มักจะแสดงในบัญชี MT4 และ MT5 ของคุณ ในช่วงเวลา 00:00 ถึง 01:00 (เวลา MT) ของวันหมดสิทธิรับเงินปันผล โดยจะมีข้อความระบุว่า 'เงินปันผล'",
        "การปรับเงินปันผลสำหรับหุ้นและ ETF CFD มักจะแสดงในบัญชี MT5 ของคุณก่อนเวลา 16:30 (เวลา MT) ของวันหมดสิทธิรับเงินปันผล โดยจะมีข้อความระบุว่า 'เงินปันผล'",
      ],
    },
    {
      q: "3.เงินปันผลส่งผลกระทบต่อการเทรดดัชนีอย่างไร",
      a: [
        "หากถือคำสั่งซื้อ: การปรับเงินปันผลจะถูกฝากเข้าบัญชี MT4 และ MT5 ของคุณ",
        "หากถือคำสั่งขาย: การปรับเงินปันผลจะถูกหักออกจากบัญชี MT4 และ MT5 ของคุณ",
        "หมายเหตุ: การปรับเงินปันผลของ ETF CFD ใช้หลักการเดียวกัน โดยอ้างอิงข้อมูลการจ่ายปันผลจากบริษัทผู้ออกกองทุน"
      ],
    },
    {
      q: "4.สูตรการคำนวณการปรับเงินปันผล",
      a: [
        "สูตรการคำนวณสำหรับคำสั่งซื้อ: จำนวนล็อต × ขนาดสัญญา × จำนวนเงินปันผลสถานะซื้อ (คำนวณเป็นสกุลเงินดัชนี)",
        "สูตรการคำนวณสำหรับคำสั่งขาย: จำนวนล็อต × ขนาดสัญญา × จำนวนเงินปันผลสถานะขาย (คำนวณเป็นสกุลเงินดัชนี)",
      ],
    },
    {
      q: "5.ตัวอย่างการคำนวณการปรับเงินปันผล",
      a: [
        "สมมติว่า SPXUSD มีวันหมดสิทธิรับเงินปันผลในวันที่ 11 ตุลาคม 2024 โดยจำนวนเงินปันผลสำหรับคำสั่งซื้อคือ 0.050 ดอลลาร์ และสำหรับคำสั่งขายคือ -0.050 ดอลลาร์",

        "หากคุณถือคำสั่งซื้อ 1 สแตนดาร์ดล็อตของ SPXUSD ในช่วงปิดตลาดก่อนวันหมดสิทธิรับเงินปันผล (วันที่ 10 ตุลาคม) การคำนวณการปรับเงินปันผลจะเป็นดังนี้:",

        "การปรับเงินปันผล = 1 (สแตนดาร์ดล็อต) × 100 (ขนาดสัญญา) × 0.050$ (จำนวนเงินปันผลคำสั่งซื้อ) = 5$",

        "วันหมดสิทธิรับเงินปันผลในช่วงเวลา 00:00 ถึง 01:00 (เวลา MT)  จำนวน 5$ จะถูกโอนเข้าสู่บัญชี MT4 และ MT5 ของคุณ โดยข้อความระบุว่า 'เงินปันผล'",
        "หากคุณถือคำสั่งขาย จำนวน 5$ จะถูกหักออกจากบัญชี MT4 และ MT5 ของคุณ โดยข้อความระบุว่า 'เงินปันผล'"

      ],
    },
    {
      q: "6.รายละเอียดสำคัญ",
      a: [
        "การปรับเงินปันผลใช้กับหุ้น ดัชนี และ ETF CFD โดยระบบจะคำนวณโดยอัตโนมัติตามจำนวนเงินปันผลในวันหมดสิทธิรับเงินปันผล ทิศทางของสถานะ และขนาดของการซื้อขาย สำหรับ ETF CFD จำนวนเงินปันผลจะพิจารณาจากประกาศอย่างเป็นทางการของกองทุนอ้างอิง และอาจมีการเปลี่ยนแปลงตามความเคลื่อนไหวของสินทรัพย์ภายในกองทุน การปรับเงินปันผลจะไม่ส่งผลต่อสเปรดหรือค่าธรรมเนียมการซื้อขาย แต่จะส่งผลต่อมูลค่าสุทธิและกำไรขาดทุนในบัญชีของคุณ หากต้องการทราบข้อมูลวันหมดสิทธิรับเงินปันผลของ ETF หรือดัชนีแต่ละรายการ กรุณาดูที่ [รายละเอียดการปรับเงินปันผล] หรือสอบถามผู้จัดการบัญชีของคุณ"
      ],
    },
  ],
};
